import {CLStore} from 'common/src/redux/store';
import initializeAiContentAgents from './initializeAiContentAgents';

function initializeAiContent(store: CLStore) {
  initializeAiContentAgents(store);
}

export default initializeAiContent;
